import styled from 'styled-components/macro'

export const H1 = styled.h1`
    font-size: ${props => props.size ? props.size : '32px'};
    line-height: ${props => props.line ? props.line : '32px'};
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : '#031D40'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    border: ${props => props.border && props.border};
    text-transform: ${props => props.textTransform && props.textTransform};
    &:hover {
        color: ${props => props.hover ? props.hover : '#031D40'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
    @media only screen and (mmin-width: 769px) {

    }
`

export const H2 = styled.h2`
    font-size: ${props => props.size ? props.size : '24px'};
    line-height: ${props => props.line ? props.line : '24px'};
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : '#031D40'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    border-left: ${props => props.borderLeft && props.borderLeft};
    text-transform: ${props => props.textTransform && props.textTransform};
    &:hover {
        color: ${props => props.hover ? props.hover : '#031D40'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
    @media only screen and (mmin-width: 769px) {
  
    }
`

export const H3 = styled.h3`
    font-size: ${props => props.size ? props.size : '20px'};
    line-height: ${props => props.line ? props.line : '20px'};
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : '#031D40'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    &:hover {
        color: ${props => props.hover ? props.hover : '#031D40'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`

export const H4 = styled.h4`
    font-size: ${props => props.size ? props.size : '20px'};
    line-height: ${props => props.line ? props.line : '20px'};
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : '#031D40'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    text-transform: ${props => props.textTransform && props.textTransform};
    &:hover {
        color: ${props => props.hover ? props.hover : '#031D40'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`

export const H5 = styled.h5`
    font-size: ${props => props.size ? props.size : '16px'};
    font-weight: ${props => props.weight && props.weight};
    line-height: ${props => props.line ? props.line : '16px'};
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : '#031D40'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    &:hover {
        color: ${props => props.hover ? props.hover : '#031D40'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`

export const P = styled.p`
    font-size: ${props => props.size ? props.size : '14px'};
    font-weight: ${props => props.weight && props.weight};
    line-height: ${props => props.line ? props.line : '14px'};
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : '#031D40'};
    margin: ${props => props.margin ? props.margin : 0};
    flex: ${props => props.flex ? props.flex : 'none'};
    text-align: ${props => props.align && props.align};
    cursor: ${props => props.cursor && props.cursor};
    text-decoration: ${props => props.decoration && props.decoration};
    text-transform: ${props => props.textTransform && props.textTransform};
    &:hover {
        color: ${props => props.hover ? props.hover : '#031D40'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`

export const Span = styled.span`
    font-size: ${props => props.size ? props.size : '14px'};
    font-weight: ${props => props.weight && props.weight};
    line-height: ${props => props.line ? props.line : '14px'};
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : '#031D40'};
    margin: ${props => props.margin ? props.margin : 0};
    flex: ${props => props.flex ? props.flex : 'none'};
    text-align: ${props => props.align && props.align};
    cursor: ${props => props.cursor && props.cursor};
    text-decoration: ${props => props.decoration && props.decoration};
    text-transform: ${props => props.textTransform && props.textTransform};
    &:hover {
        color: ${props => props.hover ? props.hover : '#031D40'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`

export const Error = styled.p`
    font-size: 16px;
    line-height: 16px;
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : 'red'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    &:hover {
        color: ${props => props.hover ? props.hover : 'red'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`

export const Success = styled.p`
    font-size: 16px;
    line-height: 16px;
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : 'green'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    &:hover {
        color: ${props => props.hover ? props.hover : 'black'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`

export const Icon = styled.p`
    font-size: 40px;
    line-height: 40px;
    padding: ${props => props.padding ? props.padding : 0};
    color: ${props => props.color ? props.color : 'black'};
    margin: ${props => props.margin ? props.margin : 0};
    text-align: ${props => props.align && props.align};
    &:hover {
        color: ${props => props.hover ? props.hover : 'black'};
    }
    a {
        color: ${props => props.color ? props.color : 'white'};
        &:hover {
            color: ${props => props.hover ? props.hover : 'crimson'};
        }
    }
`